/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-inner-declarations */
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { compact, uniq, random, omit } from 'lodash';
import { operatorTyping, setNotification } from 'utils';
import { delay } from 'redux-saga';
import { getFormsApi } from 'redux/api/formApi';
import { getFormVersionsApi } from 'redux/api/formVersionApi';
import WORKFLOW from 'containers/CRM/OrderItemsContainer/OrderItemView/workflow';
import * as OrderItemActions from '../actions/orderItemActions';
import * as Macros from './macros';
import * as OrderItemTypes from '../types/orderItemTypes';
import * as OrderItemApi from '../api/orderItemApi';
import { getPackagingApi } from '../api/packagingApi';
import { getDesignLibraryApi } from '../api/designLibraryApi';
import { getAllJobResultsApi, getJobResultApi } from '../api/jobResultApi';
import { getRollsOutApi } from '../api/rollOutApi';
import { getCoatingInApi } from '../api/coatingInApi';
import { getJobsByIdsApi } from '../api/jobApi';
import { getConfigurationsApi } from '../api/configurationApi';
import { getPrepressApi } from '../api/prepressApi';
import { getUsersApi } from '../api/userApi';
import { LOAD_LOGISTIC } from '../types/logisticTypes';
import { LOAD_REPRINT } from '../types/reprintTypes';

const getLayout = state => state.layout;
const getOrderItem = state => state.orderItem;

// L O A D   O R D E R   I T E M S
function* loadOrderItemsSaga() {
    try {
        const orderItem = yield select(getOrderItem);
        const { offset, limit, filters, sort } = orderItem;
        const params = {
            offset,
            limit,
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        let filterParams = {
            order_status: { nin: ['CANCELED', 'NEW'] },
        };

        if (filters.printingOffice !== undefined) {
            filterParams = {
                ...filterParams,
                partner_id: filters.printingOffice,
            };
        }

        if (filters.order_item_number !== '') {
            filterParams.item_order_number = filters.order_item_number.trim();
        }

        if (filters.order_number !== '') {
            filterParams.order_number = filters.order_number.trim();
        }

        if (filters.source !== undefined) {
            filterParams.source = filters.source;
        }

        if (filters.productGroup.length > 0) {
            filterParams.product_group_id = filters.productGroup;
        }

        if (filters.companyName.length > 0) {
            filterParams.customer_id = filters.companyName;
        }

        if (filters.specifications.length > 0) {
            filterParams['configurations.configuration_id'] = filters.specifications;
        }

        if (filters.quantity !== '') {
            filterParams.quantity = parseInt(filters.quantity.trim(), 10);
        }

        if (filters.state !== undefined) {
            filterParams.state = filters.state;
        }

        if (filters.transferred !== undefined) {
            filterParams.meta_board_state = filters.transferred;
        }

        if (filters.shippingMethod.length > 0) {
            filterParams.shipping_type_id = filters.shippingMethod;
        }

        if (filters.created_at.length > 0) {
            filterParams.created_at = {
                between: filters.created_at,
            };
        }

        if (filters.expected_shipping_date !== undefined) {
            filterParams.expected_shipping_date = filters.expected_shipping_date;
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield OrderItemApi.getOrderItemApi(params);

        if (result.status === 200) {
            const orderItemResult = result.data;

            let configurationsIDS = [];
            let productGroupIDS = [];
            let shippingTypeIDS = [];
            let userIDS = [];
            let customerIDS = [];

            result.data.hits.forEach((hit) => {
                (hit.configurations || []).forEach((config) => {
                    configurationsIDS.push(config.configuration_id);
                });
                productGroupIDS.push(hit.product_group_id);
                customerIDS.push(hit.customer_id);

                (hit.order || []).forEach((ord) => {
                    if (ord.shipping_type_id) {
                        shippingTypeIDS.push(ord.shipping_type_id);
                    }
                });

                hit.states.forEach(state => userIDS.push(state.updated_by));

                (hit.comments || []).forEach((comment) => {
                    if (comment.created_by) {
                        userIDS.push(comment.created_by);
                    }
                });
            });

            productGroupIDS = uniq(productGroupIDS);
            customerIDS = uniq(customerIDS);
            configurationsIDS = uniq(configurationsIDS);
            shippingTypeIDS = uniq(shippingTypeIDS);
            userIDS = uniq(userIDS);

            yield put(OrderItemActions.loadOrderItemsRes(orderItemResult));

            const macroProductGroups = yield Macros.getProductGroupsMacro(productGroupIDS);
            const macroCustomers = yield Macros.getCustomersMacro(customerIDS);
            const macroConfigurations = yield Macros.getConfigurationsMacro(configurationsIDS);
            const macroShippingTypes = yield Macros.getShippingTypeMacro(shippingTypeIDS);
            const macroUsers = yield Macros.getUsersMacro(userIDS);

            const users = macroUsers.data.hits;
            const configurations = macroConfigurations.data.hits;
            const productGroups = macroProductGroups.data.hits;
            const customers = macroCustomers?.data?.hits || [];
            const shippings = macroShippingTypes.data.hits;

            yield put(OrderItemActions.setOrderItemNeededData({
                users,
                configurations,
                productGroups,
                customers,
                shippings,
            }));
        } else {
            yield put(OrderItemActions.loadOrderItemsErr());
        }
    } catch (e) {
        yield put(OrderItemActions.loadOrderItemsErr());
        console.log(e);
    }
}

export function* loadOrderItemsWatcher() {
    yield takeLatest(OrderItemTypes.LOAD_ORDER_ITEMS, loadOrderItemsSaga);
}
// L O A D   O R D E R   I T E M S


// T O G G L E   O R D E R   I T E M   S T A T U S
function* toggleOrderItemStatusSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield OrderItemApi.toggleOrderItemStatusApi(action.data);
        if (result.status === 202) {
            if (action.data.type === 'logistics') {
                yield put({ type: LOAD_LOGISTIC });
            } else {
                yield put({ type: OrderItemTypes.LOAD_ORDER_ITEMS });
            }

            setNotification('success', locale, 'global.success', 'order.notification.toggleStep.success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(OrderItemActions.hideToggleStatusConfirmationPopup());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'order.notification.toggleStep.error');
        console.log(e);
    }
}

export function* toggleOrderItemStatusWatcher() {
    yield takeLatest(OrderItemTypes.TOGGLE_ORDER_ITEM_STATUS, toggleOrderItemStatusSaga);
}
// T O G G L E   O R D E R   I T E M   S T A T U S


// S E T   O R D E R  I T E M   C O M M E N T
function* setOrderItemCommentSaga(action) {
    try {
        const layout = yield select(getLayout);

        const { locale } = layout;

        const result = yield OrderItemApi.commentOrderItemApi(action.data);
        if (result.status === 202) {
            yield put(OrderItemActions.setOrderItemCommentRes(true, false));
            yield put(OrderItemActions.setOrderItemCommentRes(false, true));
            yield delay(1000);
            yield put(OrderItemActions.setOrderItemCommentRes(false, false));
            setNotification('success', locale, 'global.success', 'order.notification.commentItemSuccess');
            yield call(loadOrderItemsSaga);
        } else {
            setNotification('error', locale, 'global.error', 'order.notification.commentItemError');
        }
    } catch (e) {
        yield put(OrderItemActions.setOrderItemCommentErr());
        console.log(e);
    }
}

export function* setOrderItemCommentWatcher() {
    yield takeLatest(OrderItemTypes.SET_ORDER_ITEM_COMMENT, setOrderItemCommentSaga);
}
// S E T   O R D E R  I T E M   C O M M E N T

// P U T   B U L K   I N   P R O D U C T I O N
function* putBulkInProductionSaga() {
    const orderItem = yield select(getOrderItem);
    const layout = yield select(getLayout);
    const { locale, userData } = layout;

    const params = {
        bulk: [],
    };

    try {
        const eligibleOrderItems = orderItem.listing.hits.filter(hit => orderItem.checked.includes(hit._id) && hit.state !== 'MANUFACTURING');

        if (eligibleOrderItems.length === 0) {
            setNotification('error', locale, 'global.error', 'order.notification.alreadyInProduction.error');
        } else {
            /**
            * @todo modify this code, it's an anti-pattern
            */
            eligibleOrderItems.forEach((oi) => {
                params.bulk.push({
                    item_id: oi._id,
                    state: 'MANUFACTURING',
                    user_id: userData.data._id,
                });
            });

            const result = yield OrderItemApi.toggleOrderItemStatusApi(params);

            if (result.status === 202) {
                setNotification('success', locale, 'global.success', 'order.notification.putBulkInProduction.success', { number: eligibleOrderItems.length });
            } else {
                const error = yield result.json();
                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            }
        }
        yield call(loadOrderItemsSaga, {});
    } catch (e) {
        setNotification('error', locale, 'global.error', 'order.notification.putBulkInProduction.error');
        console.log(e);
    }
}

export function* putBulkInProductionWatcher() {
    yield takeLatest(OrderItemTypes.PUT_BULK_IN_PRODUCTION, putBulkInProductionSaga);
}
// P U T   B U L K   I N   P R O D U C T I O N


// P U S H   R E P R I N T
function* pushReprintSaga(action) {
    try {
        const { locale } = yield select(getLayout);

        const result = yield OrderItemApi.pushReprintApi(action.data.reprint);
        if (result.status === 202) {
            const resultState = yield OrderItemApi.pushStateApi(action.data.state);

            if (resultState.status === 202) {
                yield put(OrderItemActions.pushReprintRes());
                yield put({ type: LOAD_REPRINT });
                setNotification('success', locale, 'global.success', 'order.items.notification.pushReprint.success');
            }
        } else {
            setNotification('error', locale, 'global.error', 'order.items.notification.pushReprint.error');
        }
    } catch (e) {
        yield put(OrderItemActions.pushReprintErr());
    }
}

export function* pushReprintWatcher() {
    yield takeLatest(OrderItemTypes.PUSH_REPRINT, pushReprintSaga);
}
// P U S H   R E P R I N T


// R E P R I N T   R E Q U E S T
function* reprintRequestSaga(action) {
    try {
        const { locale } = yield select(getLayout);

        const result = yield OrderItemApi.reprintRequestApi(action.data);
        if (result.status === 202) {
            yield put(OrderItemActions.reprintRequestRes());
            setNotification('success', locale, 'global.success', 'order.items.notification.reprintRequest.success');
        } else {
            setNotification('error', locale, 'global.error', 'order.items.notification.reprintRequest.error');
        }
    } catch (e) {
        yield put(OrderItemActions.reprintRequestErr());
    }
}

export function* reprintRequestWatcher() {
    yield takeLatest(OrderItemTypes.REPRINT_REQUEST, reprintRequestSaga);
}
// R E P R I N T   R E Q U E S T


function* getOverviewOrderItem(id, orderItem, isReprint, callback) {
    if (isReprint) {
        yield put(OrderItemActions.setReprintLoading(true));
    }

    const formParams = { po_number: id };
    if (isReprint) {
        formParams.po_number = operatorTyping(`${id}${isReprint ? '_R' : ''}`);
        formParams.reprint = true;
        console.log('R E P R I N T');
    }

    const resultForm = yield getFormsApi({ filter: JSON.stringify(formParams) });

    const fragment = 100 / 8;
    const rand = () => random(fragment - 3, fragment + 3);

    if (resultForm.status === 200) {
        if (!isReprint) yield put(OrderItemActions.setOrderItemPercentage(rand()));

        let forms = resultForm.data?.hits || [];

        const orderNumberItem = orderItem.order_item_number.replace(/(PYM|PCC|IPO|IKO)_/g, '').replace(/-/g, '');
        const resultOrderItemExtra = yield OrderItemApi.getOrderItemApi({ filter: JSON.stringify({ item_order_number: orderNumberItem }) });
        const [orderItemExtra] = resultOrderItemExtra.data?.hits || [];

        if (!isReprint) yield put(OrderItemActions.setOrderItemPercentage(rand()));

        if (orderItemExtra && !isReprint) {
            const userIDS = [];

            const resultConfigurations = yield getConfigurationsApi({ filter: JSON.stringify({
                id: orderItemExtra.configurations.map(c => c.configuration_id),
                configuration_type: 'MANUFACTURING',
            }) });

            orderItemExtra.comments.filter(comment => comment.manufacturing).forEach((comment) => {
                userIDS.push(comment.created_by);
            });

            const resultUsers = yield getUsersApi({ filter: JSON.stringify({ _id: userIDS }), limit: userIDS.length });

            const users = resultUsers.data?.hits || [];
            orderItemExtra.comments = orderItemExtra.comments.filter(comment => comment.manufacturing).map((comment) => {
                const author = users.find(user => user._id === comment.created_by);
                if (author) {
                    return {
                        ...comment,
                        created_by: author,
                    };
                }

                return comment;
            });

            const configurations = resultConfigurations.data?.hits || [];
            orderItemExtra.configurations = compact(orderItemExtra.configurations.map((configuration) => {
                if (configurations.find(c => c.id === configuration.configuration_id)) {
                    return {
                        ...configuration,
                        ...(configurations.find(c => c.id === configuration.configuration_id) || {}),
                    };
                }

                return null;
            }));
        }

        if (!isReprint) yield put(OrderItemActions.setOrderItemPercentage(rand()));

        const formIDS = forms.map(f => f._id);

        const resultFormVersion = yield getFormVersionsApi({
            filter: JSON.stringify({ form_id: formIDS }),
            joins: JSON.stringify(['rolls_outs']),
        });

        const formVersions = (resultFormVersion.data?.hits || []);

        forms = forms.map(form => ({
            ...form,
            form_versions: formVersions.filter(fv => fv.form_id === form._id),
        }));

        if (!isReprint) yield put(OrderItemActions.setOrderItemPercentage(rand()));

        const coatingInID = process.env.REACT_APP_MACHINE_COATING_IN_LINE;

        let designLibrary = null;

        if (!isReprint) {
            const resultDesignLibrary = yield getDesignLibraryApi({
                filter: JSON.stringify({ prefix: uniq(forms.flatMap(form => form.design_id)).map(d => d.split('-')[0]) }),
                limit: forms.length + 1,
            });

            if (resultDesignLibrary.data?.hits.length > 0) {
                const manufacturingConfiguration = (orderItemExtra?.configurations || []).find(c => c.type === 'MANUFACTURING');
                const sizeConfiguration = (orderItemExtra?.configurations || []).find(c => !!c.configuration_property?.find(cp => cp.property.name.original_name.toLowerCase() === 'size'));

                const designVariants = resultDesignLibrary.data?.hits.map((hit => hit.design_variants.map(variant => (
                    {
                        ...variant,
                        _id: variant.design_variant_id,
                        library: [omit(hit, ['design_variants'])],
                    }
                )))).flat(2);

                designLibrary = designVariants.find((hit) => {
                    let width;
                    let height;

                    if (sizeConfiguration) {
                        [width, height] = compact((sizeConfiguration.configuration?.configuration_property || []).find(cp => cp.property.name.original_name.toLowerCase() === 'size')?.property_value.name.original_name.replace(/[a-zA-Z]/g, '').split(' ') || []).map(s => parseInt(s, 10) * 10);

                        if (!width && !height) {
                            [width, height] = [manufacturingConfiguration.width * 100, manufacturingConfiguration.height * 100];
                        }
                    } else {
                        [width, height] = orderItem.size.split('x').map(s => Math.round(parseInt(s, 10)) * 10);
                    }

                    return (hit.commercial_width === width && hit.commercial_length === height) || (hit.cutting_format_width === width && hit.cutting_format_length === height);
                });
            }
        }

        if (!isReprint) yield put(OrderItemActions.setOrderItemPercentage(rand()));

        const jobResultParams = {
            order_item_id: orderItem._id,
        };

        if (isReprint) {
            jobResultParams.reprint = true;
        }

        const resultJob = yield getJobsByIdsApi(formVersions.flatMap(fv => fv.jobs));
        const jobs = resultJob.data?.hits || [];

        const resultJobResult = yield getAllJobResultsApi({
            filter: JSON.stringify(jobResultParams),
            joins: JSON.stringify(['job']),
            limit: 100,
        });

        if (!isReprint) yield put(OrderItemActions.setOrderItemPercentage(rand()));

        const rollsoutParams = { 'steps.machine_id': process.env.REACT_APP_MACHINE_CUTTING, form_ids: formIDS };

        const resultCoatingRollsOut = yield getRollsOutApi({ filter: JSON.stringify(rollsoutParams) });
        const [qualityConfiguration] = orderItem.configurations;
        const quality = qualityConfiguration.configurations_property.find(cp => cp.type.toLowerCase() === 'quality');
        const border = qualityConfiguration.configurations_property.find(cp => cp.type.toLowerCase() === 'border');
        const workflowKey = `${border?.code !== '0' ? 'b' : ''}${quality?.code}`;
        const steps = WORKFLOW[workflowKey];

        const machineIDS = [process.env.REACT_APP_MACHINE_COLARIS, ...steps.map(step => step.machine_id)];

        const resultErrors = yield getPrepressApi({
            filter: JSON.stringify({
                machine_id: machineIDS,
                order_item_id: orderItem._id,
            }),
            limit: 999,
        });
        const prepressErrors = (resultErrors.data?.hits || []);
        const errors = machineIDS.reduce((accumulator, current) => {
            const jobResults = (resultJobResult.data?.hits || []).map(jb => jb.job[0]._id);
            const countErrors = prepressErrors
                .filter(pe => pe.machine_id === current)
                .filter(pe => jobResults.includes(pe.job_id))
                .reduce((acc, curr) => acc + curr.quantity, 0);
            const countNoErrors = prepressErrors.filter(pe => pe.machine_id === current).reduce((acc, curr) => acc + curr.quantity, 0);

            return {
                ...accumulator,
                [current]: {
                    count: countErrors,
                    no_errors: countNoErrors,
                },
            };
        }, {});

        if (!isReprint) yield put(OrderItemActions.setOrderItemPercentage(rand()));

        const coatingInParams = { machine_id: coatingInID, order_item_id: orderItem._id };
        if (isReprint) coatingInParams.reprint = true;

        const resultCoatingRollsIn = yield getCoatingInApi({ filter: JSON.stringify(coatingInParams) });

        const coatingRollsIn = resultCoatingRollsIn.data?.hits || [];

        yield put(OrderItemActions.setOrderItemPercentage(rand()));

        const jobResults = (resultJobResult.data?.hits || []).filter(jr => jr.parent === null || jr.delete);

        const resultJobResultOrigin = yield getJobResultApi({ filter: JSON.stringify({ order_item_id: orderItem._id }) });

        const jobResultsCoatingIn = (resultJobResultOrigin.data?.hits || []).filter(jr => jr.parent !== null).filter(jr => (
            !!(jr.steps_tracking || []).find(st => st.machine_id === coatingInID)
        ));

        yield callback({
            orderItem,
            orderItemExtra: orderItemExtra || null,
            designLibrary: designLibrary || null,
            forms,
            jobs,
            jobResults,
            coatingRollsOut: resultCoatingRollsOut.data?.hits || [],
            coatingRollsIn: coatingRollsIn.reduce((acc, curr) => (acc + curr.quantity), 0) || null,
            jobResultsCoatingIn,
            errors,
        });
    } else {
        yield put(OrderItemActions.loadOrderItemErr());
    }
}


// L O A D   O R D E R   I T E M
function* loadOrderItemSaga(action) {
    try {
        const resultOrderItem = yield getPackagingApi({ filter: JSON.stringify({ order_item_number: action.id }) });
        const [orderItem] = resultOrderItem.data?.hits || [];

        yield getOverviewOrderItem(
            action.id,
            orderItem,
            false,
            function* callback({
                orderItemExtra,
                designLibrary,
                forms,
                jobs,
                jobResults,
                coatingRollsOut,
                coatingRollsIn,
                jobResultsCoatingIn,
                errors,
            }) {
                yield put(OrderItemActions.loadOrderItemRes({
                    orderItem,
                    orderItemExtra,
                    designLibrary,
                    forms,
                    jobs,
                    jobResults,
                    coatingRollsOut,
                    coatingRollsIn,
                    jobResultsCoatingIn,
                    errors,
                }));
            },
        );

        yield getOverviewOrderItem(
            action.id,
            orderItem,
            true,
            function* callback({
                forms,
                jobResults,
                coatingRollsOut,
                coatingRollsIn,
                jobs,
                errors,
            }) {
                yield put(OrderItemActions.setReprintLoading(false));
                yield put(OrderItemActions.setReprintData({
                    forms,
                    jobResults,
                    coatingRollsOut,
                    coatingRollsIn: coatingRollsIn ? coatingRollsIn.quantity : null,
                    jobs,
                    errors,
                }));
            },
        );
    } catch (e) {
        yield put(OrderItemActions.loadOrderItemErr());
        yield put(OrderItemActions.setReprintLoading(false));
        console.log(e);
    }
}

export function* loadOrderItemWatcher() {
    yield takeLatest(OrderItemTypes.LOAD_ORDER_ITEM, loadOrderItemSaga);
}
// L O A D   O R D E R   I T E M
